'use client'

import { RandomWelcomeProjectFragment } from '@/gql/generated/graphql'
import { ArrowRightIcon, DisplayText, HeadlineText } from 'design-configuration/components'
import { ProjectsAnimation } from '@components/projects-animation'
import { OverlineHeader } from '@components/overline-header'
import { AllPurposeLink } from '@components/all-purpose-link'
import { cn } from '@/lib/utils'
import { allCollectionsRoute } from '@utils/routes'
import { trackButtonClicked, TrackedButtonNames } from '@utils/analytics'
import { buttonVariants } from '@components/button'
import React from 'react'

type InspireProps = {
  projects?: RandomWelcomeProjectFragment[]
}

export function Inspire({ projects }: InspireProps): React.ReactElement {
  const [isHovered, setIsHovered] = React.useState(false)

  return (
    <section
      className="bg-surface-low relative flex h-[600px] w-full flex-col items-center overflow-hidden md:h-[80vh] md:flex-row"
      style={{
        boxShadow: '0px 0px 12.8px 0px rgba(0, 0, 0, 0.15) inset'
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Text content on the left */}
      <div className="p-2xl flex w-full flex-col justify-center md:w-3/5">
        <OverlineHeader text="Collections that inspire" />
        <DisplayText className="my-sm">Your next favorite collection awaits</DisplayText>
        <HeadlineText className="font-light">
          Dive into the world of iconic, groundbreaking collections loved by collectors around the globe.
        </HeadlineText>
        <AllPurposeLink
          className={cn(
            buttonVariants({ colorTheme: 'secondary', branded: true }),
            'mt-2xl gap-x-xs flex w-fit items-center bg-transparent'
          )}
          href={allCollectionsRoute}
          onClick={() => {
            trackButtonClicked(TrackedButtonNames.homeViewAllCollections)
          }}
        >
          View all
          <ArrowRightIcon className="fill-inherit" />
        </AllPurposeLink>
      </div>

      {/* ProjectsAnimation on the right */}
      <div className="pointer-events-none absolute bottom-0 right-0 top-0 h-full w-full">
        <ProjectsAnimation projects={projects} isHovered={isHovered} />
      </div>
    </section>
  )
}
